import { useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

// Reveal children with class `reveal` when the container enters the viewport.
// Keeps it subtle: short fade + 16px rise, staggered.
export function useReveal({ selector = '.reveal', y = 16, stagger = 0.06, start = 'top 85%' } = {}) {
  const ref = useRef(null);

  useEffect(() => {
    const scope = ref.current;
    if (!scope) return;

    const targets = scope.querySelectorAll(selector);
    if (!targets.length) return;

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (reduceMotion) {
      gsap.set(targets, { opacity: 1, y: 0 });
      return;
    }

    const ctx = gsap.context(() => {
      gsap.fromTo(
        targets,
        { opacity: 0, y },
        {
          opacity: 1,
          y: 0,
          duration: 0.7,
          ease: 'power2.out',
          stagger,
          scrollTrigger: {
            trigger: scope,
            start,
            once: true,
          },
        }
      );
    }, scope);

    return () => ctx.revert();
  }, [selector, y, stagger, start]);

  return ref;
}
